/**
 * Invoice line item. Subcollection: org/{orgId}/invoice/{invoiceId}/item
 * Resolve the repository with context { orgId, invoiceId }.
 *
 * Owned child row (no lifecycle). Audit via {@link Auditable} / ChildCrudService.
 * Invariants (totals, ≥1 item, line numbers) are enforced in invoiceService.
 *
 * Product reference follows canonical {@link ProductRef}: `productId` + optional
 * **partial** `variantId`. Size breakdown (when needed) is a phase-G follow-up.
 *
 * Debt (phase G / 0111): `lot` and `warehouseId` remain free-text on the fiscal
 * document; reconcile to `Lot` / `StockLocation` (via WarehouseMap) when posting stock.
 */
export const INVOICE_ITEM = 'InvoiceItem';
//# sourceMappingURL=invoice-item.js.map